import React from "react";
import { CloseButton } from "react-bootstrap";
import theme from "../../../../Utils/theme";
import Fontstyling from "../../comman";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import moment from "moment";

const FeesBadge = ({
  item,
  feesArrays,
  setFeesArrays,
  witchFees,
  setLength20Error,
}) => {
  return (
    <div
      style={{
        width: "fit-content",
        position: "relative",
      }}
    >
      <div
        style={{
          padding: "10px 10px",
          margin: "10px 10px",
          backgroundColor: theme.PRIMARY_ARCTIC_GRAY,
          overflow: "auto",
        }}
        className={`d-flex w-auto position-relative badge rounded-pill gap-4 align-items-center text-dark`}
      >
        {item?.subFeeName !== "Create new fee" && (
          <div style={{ ...Fontstyling.label, fontWeight: "800" }}>
            {item?.subFeeName}
          </div>
        )}
        {item.subFeeNameAlias && (
          <div style={{ ...Fontstyling.label, fontWeight: "800" }}>
            {item.subFeeNameAlias}
          </div>
        )}
        <div style={{ ...Fontstyling.label, fontWeight: "800" }}>
          {item.feeTypeName}
        </div>
        <div style={Fontstyling.label}>{item.feeTypeNameAlias}</div>
        <div style={Fontstyling.label}>${item.amount}</div>
        {item?.budgetedMonth && (
          <div style={Fontstyling.label}>
            {moment(item.budgetedMonth).format("MM-DD-YYYY")}
          </div>
        )}
      </div>
      <div
        className="position-absolute cursor-pointer rounded-circle bg-light p-0"
        style={{
          right: 0,
          top: 0,
        }}
        // className="position-absolute cursor-pointer rounded-circle bg-light p-0"
        // style={{
        //   top: "-5px",
        //   right: "-5px",
        // }}
        onClick={() => {
          setLength20Error((prev) => ({ ...prev, [witchFees]: false }));
          setFeesArrays((prev) => ({
            ...feesArrays,
            [witchFees]: feesArrays[witchFees].filter(
              (obj) => item.subFeeID !== obj.subFeeID
            ),
          }));
        }}
      >
        <HighlightOffIcon color="error" />
      </div>
    </div>
  );
};

export default FeesBadge;
